var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text",style:(_vm.styleColor)},[_vm._v(_vm._s(_vm.timestr))])
}
var staticRenderFns = []

export { render, staticRenderFns }